// @flow

import * as React from 'react';
import { Route, IndexRedirect, IndexRoute } from 'react-router';
import { compose } from 'redux';

import { provideAssetPath } from 'gandi.react-asset-path';
import { provideTranslate } from '@gandi/translate';
import { withPageMeta } from '@gandi/app-runner/dist/utils/withPageMeta';

import Root from './containers/Root';
import NotFound from './containers/NotFound';
import ContactSupport from './Support/Contact';
import Success from './Support/Contact/components/Success';
import Abuse from './Abuse';
import Trustpilot from './Trustpilot';
import DispatchUnsubscriptions from './Unsubscriptions';
import Unsubscription from './Unsubscription';
import UnsubscriptionSuccess from './Unsubscription/Success';
import UnsubscriptionsSuccess from './Unsubscriptions/Success';

export const routes: React.Element<typeof React.Fragment> = (
  <Route>
    <IndexRedirect to="contact" />
    <Route
      path="contact(/:subject(/:topic))"
      component={ContactSupport}
      tracking={{ chapter2: 'Form', chapter3: ':subject', name: ':topic' }}
    />
    <Route path="success" component={Success} tracking={{ chapter2: '' }} />
    <Route
      path="abuse(/:category(/:topic))"
      component={Abuse}
      tracking={{ chapter2: 'Abuse', chapter3: ':category', name: ':topic' }}
    />
    <Route
      path="unsubscription/:token"
      tracking={{ chapter2: 'Unsubscription' }}
    >
      <IndexRoute component={Unsubscription} />
      <Route path="success" component={UnsubscriptionSuccess} />
    </Route>
    <Route
      path="unsubscription/:campaignSlug/:token"
      tracking={{ chapter2: 'Unsubscription', chapter3: ':campaignSlug' }}
    >
      <IndexRoute component={DispatchUnsubscriptions} />
      <Route path="success" component={UnsubscriptionsSuccess} />
    </Route>
    <Route
      path="trustpilot/:token"
      component={Trustpilot}
      tracking={{ chapter2: 'Trustpilot', name: 'redirect-error' }}
    />
    <Route path="*" component={NotFound} />
  </Route>
);

export default (args: any): React.Element<typeof Route> => {
  const DecoratedApp = compose(
    provideTranslate(args.translator),
    provideAssetPath(
      args.assetEndpoint,
      args.manifestContent,
      args.assetPrefix
    ),
    // $FlowFixMe[prop-missing]
    withPageMeta(({ __, params }) => {
      let title = __('Contact our customer support team - Gandi.net');
      let description = __(
        'Our expert in-house customer support team is free of charge and available to help you 24/7, in 5 different languages.'
      );

      switch (params.subject) {
        case 'reseller-contact':
          title = __('Have a question about our reseller options? - Gandi.net');
          description = __(
            'Our team is here to help. Contact our reseller team to become a reseller with Gandi services and accelerate your business growth.'
          );
          break;
        case 'corporate-contact':
          title = __('Contact Gandi Corporate Services - Gandi.net');
          description = __(
            'Contact our sales team to get a tailored quote. 20-years of experience by experts who are dedicated and available every day.'
          );
          break;
        case 'my-rights':
          title = __('Exercise Your GDPR Rights - Gandi.net');
          description = __(
            'Fill out the form in this page to exercise your rights to your personal data, notably the right of rectification, erasure, and restriction of data processed by Gandi.'
          );
          break;
        default:
        // Pass
      }

      return {
        title,
        description,
      };
    })
  )(Root);

  return (
    <Route
      name="app"
      path="/"
      component={DecoratedApp}
      tracking={{ chapter1: 'Help' }}
    >
      {routes}
    </Route>
  );
};
